import { render, staticRenderFns } from "./Platformer.vue?vue&type=template&id=0f274688&scoped=true&"
import script from "./Platformer.vue?vue&type=script&lang=ts&"
export * from "./Platformer.vue?vue&type=script&lang=ts&"
import style0 from "./Platformer.vue?vue&type=style&index=0&id=0f274688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f274688",
  null
  
)

export default component.exports